export default "\r\n<app-nav>\t\t\r\n\t<router-outlet></router-outlet>\t\r\n\t<app-notifications></app-notifications>\t\r\n</app-nav>\r\n"